/**
 * Feature-detected haptic feedback helper.
 *
 * Wraps `navigator.vibrate` with a small set of named patterns so call sites
 * share a single, consistent vocabulary instead of scattering raw vibrate
 * durations. Silently no-ops when the Vibration API is unavailable (desktop,
 * iOS Safari) — callers don't need to guard.
 */
export type HapticPattern = 'light' | 'success' | 'warning'

const PATTERNS: Record<HapticPattern, number | number[]> = {
  // 가벼운 탭 확인 (체크박스, 롱프레스 진입)
  light: 10,
  // 긍정적 완료 (작업 추가/완료)
  success: [10, 40, 10],
  // 파괴적/경고 동작 (삭제 스와이프)
  warning: [10, 40, 10, 40, 10],
}

export function haptic(pattern: HapticPattern = 'light'): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') {
    return
  }
  // 사용자 제스처 이전 vibrate는 브라우저가 차단하며 콘솔 에러를 남김 — 게이트로 방지
  if (typeof navigator.userActivation !== 'undefined' && !navigator.userActivation.hasBeenActive) {
    return
  }
  try {
    navigator.vibrate(PATTERNS[pattern])
  } catch {
    // 일부 브라우저는 사용자 제스처 외 호출 시 throw — 무시
  }
}
